import { render, staticRenderFns } from "./UserPasswordRecoveryView.vue?vue&type=template&id=10d9c2c3&scoped=true"
import script from "./UserPasswordRecoveryView.vue?vue&type=script&lang=ts"
export * from "./UserPasswordRecoveryView.vue?vue&type=script&lang=ts"
import style0 from "./UserPasswordRecoveryView.vue?vue&type=style&index=0&id=10d9c2c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d9c2c3",
  null
  
)

export default component.exports